import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CustomAttributeSearchTermDataState from "@tCentro/Store/Data/CustomAttributeSearchTermDataState";

import { Draft } from "immer";

const initialState: CustomAttributeSearchTermDataState = {
    searchText: "",
};

const reducer = {
    "Custom/ProductListCardList/AttributeFilterSearchTerm": (draft: Draft<CustomAttributeSearchTermDataState>, action: { data: string }) => {
        draft.searchText = action.data;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
